// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#plus-credit-popover[data-v-8e5d403a]{left:0!important;right:auto!important}#plus-credit-popover[data-v-8e5d403a]:before{border-bottom-color:#f0deff!important;left:3.4rem!important}@media screen and (min-width:64rem){#plus-credit-popover[data-v-8e5d403a]{left:auto!important;right:0!important}#plus-credit-popover[data-v-8e5d403a]:before{left:13.6rem!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
